import './utils/translationCrashGuard';
import React from 'react';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import './assets/scss/style.scss';
import App from './components/App';
import { setConfiguration } from 'react-grid-system';

setConfiguration({ maxScreenClass: 'xl', containerWidths: [1164, 1164, 1164, 1164] });

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
